import script from "./Application.vue?vue&type=script&setup=true&lang=js"
export * from "./Application.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__